import { CandidateTechStacksType } from '@/types';
import { EditReviewerData } from '../ChallengeReviewers.container';

export const checkShouldShowConfirmationModal = ({
  reviewerToEdit,
  selectedSkills,
  isEditMode,
  showConfirmationModal,
}: {
  reviewerToEdit?: EditReviewerData;
  selectedSkills: CandidateTechStacksType[];
  isEditMode: boolean;
  showConfirmationModal: boolean;
}): boolean => {
  if (!isEditMode) {
    return false;
  }

  const selectedSkillsIds = selectedSkills.map((skill) => skill.skill.id);
  const wasSomeSkillRemoved = reviewerToEdit?.skills.some((skill) => {
    return !selectedSkillsIds.includes(skill.skill.id);
  });

  return !!wasSomeSkillRemoved && !showConfirmationModal;
};

export const getNewSkillMock = (): CandidateTechStacksType => {
  return {
    id: `temp-${Date.now()}`,
    skill: { id: '', name: '', createdAt: '', updatedAt: '' },
    isMainStack: false,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    willingToReview: true,
  };
};
